module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"FooterMain":{"navigation":{"ariaLabel":"Menu v zápatí"}}},"en":{"FooterMain":{"navigation":{"ariaLabel":"Menu in the footer"}}}}')
  delete Component.options._Ctor
}
